// src/components/dashboard/customStudy/CycleSelector.tsx
// REFATORADO: Verde Militar + Ícones Lucide

import React from 'react';
import { Cycle } from '../types';
import { BookOpen, Check, Lock } from 'lucide-react';

interface CycleSelectorProps {
    cycles: Cycle[];
    selectedCycleIds: string[];
    onToggle: (cycleId: string) => void;
}

const CycleSelector: React.FC<CycleSelectorProps> = ({
    cycles,
    selectedCycleIds,
    onToggle
}) => {
    return (
        <div className="selector-section">
            <div className="selector-header">
                <h3>
                    <BookOpen size={22} style={{ display: 'inline-block', verticalAlign: 'middle', marginRight: '10px' }} />
                    Passo 1: Selecione os Campos de Estudo
                </h3>
                <span className="selection-count">
                    {selectedCycleIds.length} selecionado{selectedCycleIds.length !== 1 ? 's' : ''}
                </span>
            </div>

            <div className="selector-grid">
                {cycles.map(cycle => {
                    const isSelected = selectedCycleIds.includes(cycle._id);

                    // ✅ Bloqueado se: não comprou E não tem nenhum deck
                    const hasAnyDeck = cycle.decks && cycle.decks.some((d: any) => d.purchased);
                    const isLocked = !cycle.purchased && !hasAnyDeck;

                    return (
                        <button
                            key={cycle._id}
                            className={`selector-card ${isSelected ? 'selected' : ''} ${isLocked ? 'blocked' : ''}`}
                            onClick={() => !isLocked && onToggle(cycle._id)}
                            disabled={isLocked}
                            style={{ opacity: isLocked ? 0.5 : 1 }}
                        >
                            <div className="selector-card-header">
                                <div className="selector-checkbox">
                                    {isSelected && <Check size={16} />}
                                </div>
                                <h4>
                                    {isLocked && <Lock size={14} style={{ marginRight: '6px', display: 'inline-block', verticalAlign: 'middle' }} />}
                                    {cycle.name}
                                </h4>
                            </div>

                            <div className="selector-stats">
                                <span className="stat-badge">
                                    {cycle.deckCount} deck{cycle.deckCount !== 1 ? 's' : ''}
                                </span>
                            </div>

                            {/* ✅ AVISO DE BLOQUEIO */}
                            {isLocked && (
                                <div className="graia-lock-hint">
                                    <Lock size={14} />
                                    <span>Adquira este campo para usar no estudo personalizado</span>
                                </div>
                            )}
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default CycleSelector;